import FastAPIInstance from '../../services/risksystem3-public-api';
import { ClientType, FundManager } from './types';

/** Identifier type for the client search endpoint. */
export type ClientIdentifierType = 'client_id' | 'client_name';

/**
 * Search for a client by identifier (mirrors backend searchClient).
 * GET /v1/client/{client_identifier_type}/{client_identifier_value}
 */
export const searchClient = async (
  clientIdentifierType: ClientIdentifierType,
  clientIdentifierValue: string,
): Promise<ClientType | null> => {
  const { data } = await FastAPIInstance.get<ClientType | null>(
    `/v1/clients/${clientIdentifierType}/${clientIdentifierValue}`,
  );
  return data ?? null;
};

/**
 * Fetch a single client by id (convenience wrapper for searchClient).
 * Returns null if not found.
 */
export const getClient = async (
  clientId: string,
): Promise<ClientType | null> => {
  return searchClient('client_id', clientId);
};

export const getAllFundManagersForClient = async (clientId: string) => {
  return (
    await FastAPIInstance.get<FundManager[]>(`/v1/fund_manager/${clientId}`)
  ).data;
};
